"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignProductListRequest = void 0;
var AssignProductListRequest = /** @class */ (function () {
    function AssignProductListRequest() {
    }
    return AssignProductListRequest;
}());
exports.AssignProductListRequest = AssignProductListRequest;
;
//# sourceMappingURL=assignProductList.request.js.map